import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Guarantee() {
  return <section className="relative w-full border-t-2 border-bone/10 bg-steel py-12 sm:py-24" aria-labelledby="garantia-title" data-id="element-35" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-8" data-id="element-36" data-mp="1x4bs2xzkkrbb">
        <ShieldCheckIcon className="mx-auto h-10 w-10 text-chartreuse sm:h-12 sm:w-12" aria-hidden="true" data-id="element-37" data-mp="1x54pv9gjw6hb" />
        <p className="mt-4 font-cond text-xs uppercase tracking-[0.28em] text-chartreuse sm:mt-5 sm:text-sm" data-id="element-38" data-mp="14fnz0g8kwxn7">
          Garantía de hierro
        </p>
        <h2 id="garantia-title" className="mt-3 font-display text-2xl uppercase leading-[0.95] text-bone sm:mt-4 sm:text-5xl" data-id="element-39" data-mp="1j651m2wy9tlo">
          Dos salidas al agua.
          <span className="block text-chartreuse" data-id="element-40" data-mp="qmyeyhcm22sq">Si no sientes el ataque, te devolvemos todo.</span>
        </h2>
        <p className="mt-4 font-body text-[0.95rem] leading-relaxed text-bone/80 sm:mt-6 sm:text-lg" data-id="element-41" data-mp="lon3k26o3k8e">
          Amarra el Pitbull, tírale con el Senko, arrastra el Cangrejo. Dale dos
          jornadas completas. Si el instinto del pez no responde, si sientes que
          la textura o la vibración no están a la altura de lo que acabas de
          leer, escríbenos por WhatsApp con una foto de tu pack.
        </p>
        <p className="mt-4 font-cond text-lg uppercase leading-snug tracking-wide text-bone sm:mt-5 sm:text-xl" data-id="element-42" data-mp="12t0ua2kruje4">
          Te regresamos tus $399 completos y los señuelos usados te los quedas.
          Sin formularios, sin devoluciones, sin cara larga. El riesgo lo
          cargamos nosotros — a ti te toca clavar.
        </p>
        <CtaButton size="md" source="garantia" className="mt-7 w-full sm:hidden" data-id="element-43" data-mp="k06rs84c4jqs">
          ¡Quiero pescar más ya!
        </CtaButton>
        <CtaButton source="garantia" className="mt-10 hidden sm:inline-flex" data-id="element-44" data-mp="1qfph92on121l">
          ¡Quiero pescar más ya!
        </CtaButton>
      </div>
    </section>;
}